import boxShadows from "assets/theme/box-shadow.js";

const componentStyles = (theme) => ({
  listItemRoot: {
    padding: "1.5rem!important",
    borderBottom: "1px solid " + theme.palette.gray[200],
  },
  companyLogo: {
    width: "15px",
    height: "15px",
    marginRight: "10px",
  }
});

export default componentStyles;
